"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var LoggerModule_1 = __importDefault(require("./LoggerModule"));
var Logger = /** @class */ (function () {
    function Logger(name) {
        var _this = this;
        if (name === void 0) { name = ''; }
        this.name = '';
        this.__listeners = [];
        this.__modules = {};
        this.__emit = function (logMessage) {
            _this.__listeners.forEach(function (listener) {
                listener.notify(logMessage);
            });
        };
        this.__log = function (moduleName, level, message, extendedData) {
            var logMessage = {
                loggerName: _this.name,
                timestamp: Date.now(),
                level: level,
                moduleName: moduleName,
                message: message,
                extendedData: extendedData,
            };
            _this.__emit(logMessage);
        };
        this.name = name;
    }
    Logger.prototype.module = function (moduleName) {
        var module = this.getModule(moduleName);
        if (!module) {
            module = new LoggerModule_1.default(moduleName, this.__log);
            this.__addModule(module);
        }
        return module;
    };
    Logger.prototype.getModule = function (moduleName) {
        return this.__modules[moduleName] || null;
    };
    Logger.prototype.getModules = function () {
        return this.__modules;
    };
    Logger.prototype.__addModule = function (module) {
        this.__modules[module.name] = module;
    };
    Logger.prototype.addListener = function (listener) {
        this.__listeners.push(listener);
    };
    Logger.prototype.removeListener = function (listener) {
        this.__listeners = this.__listeners.filter(function (item) { return item !== listener; });
    };
    Logger.prototype.removeAllListeners = function () {
        this.__listeners = [];
    };
    return Logger;
}());
exports.default = Logger;
//# sourceMappingURL=Logger.js.map